module.exports = __webpack_public_path__ + "img/worksbot_img20021104.8bae035c.jpg";